import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_SUPPORT_SUMMARY, GET_SUPPORT_SUMMARY_SUCCESS, GET_SUPPORT_SUMMARY_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getSupportSummary({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { ticketId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/tickets/${ticketId}/transfer-history`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_SUPPORT_SUMMARY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_SUPPORT_SUMMARY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SUPPORT_SUMMARY_ERROR, payload: error });
  }
}

export function* watchGetSupportSummary() {
  yield takeEvery(GET_SUPPORT_SUMMARY, getSupportSummary);
}

function* getSupportSummarySaga() {
  yield all([fork(watchGetSupportSummary)]);
}

export default getSupportSummarySaga;
